<app-nav-bar></app-nav-bar>
<app-side-bar></app-side-bar>
<app-settings-modal></app-settings-modal>

<div class="container">
  <div class="container-clients">
    <div class="header">
      <h1 class="title">{{'VALIDATE_CLIENT' | translate}}</h1>
    </div>
    <div class="form-card">
      <div class="search-container">
        <input
          type="text"
          placeholder="{{'SEARCH' | translate}}"
          [(ngModel)]="searchString"
        />
        <button (click)="serchClient()" type="button" class="btn primary-btn">{{'SEARCH' | translate}}</button>
      </div>
      <div class="loading" *ngIf="loading">
        <div class="spinner-border" role="status"></div>
      </div>
      <div *ngIf="!loading && dataStatus == 2">
        <h6 class="text-center">{{'VALIDATE_CLIENT_HELP_TEXT' | translate}}</h6>
      </div>
      <div *ngIf="!loading && dataStatus == 0">
        <h6 class="text-center">{{'NO_RESULTS' | translate}}</h6>
      </div>
      <div class="container-fluid row" *ngIf="!loading && dataStatus == 1">
        <div class="col-md-4" *ngIf="client">
          <div *ngIf="!loading" class="form-card info">
            <table class="client-info-container">
              <tr>
                <th>{{ 'CUSTOMER_INFORMATION' | translate }}</th>
              </tr>
              <tr>
                <td>{{'NAME' | translate}}: {{ client?.firstName || ''}} {{ client?.lastName || ''}}</td>
              </tr>
              <tr>
                <td *ngIf="client.documentType == 'ID'">{{ 'IDENTIFICATION' | translate }}: {{ client?.nationalId || '' }}</td>
                <td *ngIf="client.documentType == 'Passport'">{{ 'PASSPORT' | translate }}: {{ client?.nationalId || '' }}</td>
                <td *ngIf="client.documentType == 'DIMEX'">{{ 'DIMEX' | translate }}: {{ client?.nationalId || '' }}</td>
              </tr>
              <tr>
                <td>{{'EMAIL' | translate}}: {{ client?.email || '' }}</td>
              </tr>
              <tr>
                <td>{{'PHONE' | translate}}: {{ client?.phone || '' }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="col-md-8" *ngIf="client">
          <div class="form-card">
            <h3 class="subtitle">{{'ITEMS' | translate}}</h3>
            <div class="row d-flex">
              <div class="col-md-12">
                <div class="order-item row" *ngFor="let item of client.items">
                  <div class="item-image col-md-3">
                    <img *ngIf="item.imageURL" [src]="item.imageURL">
                    <img *ngIf="!item.imageURL" src="/assets/static/missing-image.png">
                  </div>
                  <div class="item-info col-md-9 row" style="overflow: auto;">
                    <div class="item-title col-md-12">
                      <span>{{ item.productName }}</span>
                    </div>
                    <!-- <div class="col-md-12 item-variant">
                      <span *ngFor="let variant of item.variants">
                        {{ variant.variantTypeName }} {{ variant.variantValueName }}
                      </span>
                    </div> -->
                    <div class="col-md-12 item-code">
                      <span class="info-title">{{ 'CODE' | translate }}: </span>
                      <span>{{ item.itemCode }}</span>
                    </div>
                    <!-- <div class="col-md-12">
                      <span class="info-title">{{ 'POINT_OF_SALE' | translate }}: </span>
                      <span>{{ item.shopPointName }}</span>
                    </div> -->
                    <div class="col-md-6">
                      <span class="info-title">{{ 'QUANTITY' | translate }}: </span>
                      <span>{{ item.saleItemQuantity }}</span>
                    </div>
                    <div class="col-md-6 item-price">
                      <span>{{ 'PRICE' | translate }}: {{ appComponent.formatMoney(item.saleItemUnitCost) }}</span>
                    </div>
                    <div class="col-md-12">
                      <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                          <button class="nav-link active" id="description-tab{{ item.saleId }}{{ item.itemId }}" data-bs-toggle="tab" [attr.data-bs-target]="'#descriptionTab' + item.saleId + item.itemId" type="button" role="tab" aria-controls="home" aria-selected="true" *ngIf="![10, 12].includes(themingService.shopTheming[0].shopId)">{{'DETAILS' | translate}}</button>
                          <button class="nav-link active" id="conditions-tab{{ item.saleId }}{{ item.itemId }}" data-bs-toggle="tab" [attr.data-bs-target]="'#descriptionTab' + item.saleId + item.itemId" type="button" role="tab" aria-controls="home" aria-selected="true" *ngIf="[10, 12].includes(themingService.shopTheming[0].shopId)">{{'PLAN_SUMMARY' | translate}}</button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link" id="conditions-tab{{ item.saleId }}{{ item.itemId }}" data-bs-toggle="tab" [attr.data-bs-target]="'#conditionsTab' + item.saleId + item.itemId" type="button" role="tab" aria-controls="profile" aria-selected="false">{{'CONDITIONS' | translate}}</button>
                        </li>
                      </ul>
                      <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="descriptionTab{{ item.saleId }}{{ item.itemId }}" role="tabpanel" aria-labelledby="description-tab">
                          <div class="detail ql-editor" id="product-detail{{ item.saleId }}{{ item.itemId }}" [innerHTML]="item.productDescription"></div>
                        </div>
                        <div class="tab-pane fade" id="conditionsTab{{ item.saleId }}{{ item.itemId }}" role="tabpanel" aria-labelledby="conditions-tab">
                          <div class="detail ql-editor" id="product-detail{{ item.saleId }}{{ item.itemId }}" [innerHTML]="item.productConditions">{{item.productDescription}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</div>

<app-footer></app-footer>